
const initialState = {
    data: null
};

const FormularioReducer = function (state = initialState, action) {
    switch (action.type) {
        default:
            {
                return state;
            }
    }
};

export default FormularioReducer;
